module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mrgbt-4 px-2 w-full"
  }, [_c('div', [_c('input', {
    attrs: {
      "id": _vm.id,
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.handleChange($event.target.checked)
      }
    }
  }), _vm._v(" "), (_vm.showLabel) ? _c('BaseLabel', {
    attrs: {
      "for": _vm.id,
      "info-tooltip": _vm.infoTooltip,
      "tooltip-size": _vm.tooltipSize
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d39381c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseCheckbox.vue
// module id = 113
// module chunks = 0